import { Carousel } from '@/components';
import { splitArrayIntoSubArrays } from '@/utils';
import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `CardsGrid`.
 */
export type CardsGridProps = SliceComponentProps<Content.CardsGridSlice>;

/**
 * Component for "CardsGrid" Slices.
 */
const CardsGrid = ({ slice }: CardsGridProps): JSX.Element => {
  const renderColumns = () => {
    const numberOfColumns = slice.primary.number_of_columns || 3;
    const pageSize = Math.floor(slice.primary.card.length / numberOfColumns);
    const columns = splitArrayIntoSubArrays(slice.primary.card, pageSize);
    return columns.map((column, col_index) => {
      return (
        <div key={`column_desktop_${col_index.toString()}`} className="h-full">
          <div className={`flex flex-col grow basis-1 gap-y-8 md:h-auto mx-1`}>
            {column.map((card, index) => {
              return (
                <div
                  key={`$card_desktop_${col_index}_${index}`}
                  className={`flex flex-col gradient-border ${card.isicon ? 'justify-center grow' : 'justify-start'} mb-[1px]`}
                >
                  <div className={card.isicon ? 'p-8 pb-6' : 'pb-8'}>
                    <PrismicNextImage field={card.image} />
                  </div>
                  <div className="p-8 pt-0 flex flex-col gap-4 grow">
                    <h3 className="text-h4">{card.title}</h3>
                    <div>{card.description}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="text-white px-5 py-6 md:px-16 md:py-16 flex flex-col md:gap-20 gap-10 max-w-screen-2xl mx-auto"
    >
      <div className="text-center flex flex-col md:gap-6 gap-3">
        <PrismicRichText field={slice.primary.title} />
        <PrismicRichText field={slice.primary.description} />
      </div>
      <div className="hidden lg:flex flex-row gap-8">{renderColumns()}</div>
      <div className="lg:hidden">
        <Carousel renderDotsOutside arrows={false} dotType="compact-dark">
          {renderColumns()}
        </Carousel>
      </div>
    </section>
  );
};

export default CardsGrid;
